import { KeyboardKeys } from 'app/enums'
import { Dialog } from 'elements/feedback'
import { Button, ButtonProps } from 'elements/inputs'
import { useBoolean } from 'lib/hooks'
import { ReactNode, useEffect } from 'react'
import { isMacOs } from 'react-device-detect'
import { useTranslation } from 'react-i18next'
import useKeyboardJs from 'react-use/lib/useKeyboardJs'

import { CreateTermDialog } from './create-term-dialog'

export const CreateTermButton = ({
  projectId,
  startIcon,
  ...props
}: {
  projectId: string
  startIcon?: ReactNode
} & ButtonProps) => {
  const { t } = useTranslation()

  const [isPressed] = useKeyboardJs(KeyboardKeys.AltT)

  const isOpen = useBoolean()

  useEffect(() => {
    if (isPressed) isOpen.setTrue()
  }, [isOpen, isPressed])

  return (
    <>
      <Button
        onClick={isOpen.setTrue}
        {...(startIcon && {
          startIcon,
        })}
        {...props}
      >
        {`${isMacOs ? '⌥' : 'Alt'}T ${t('projects.terms.create_new_term')}`}
      </Button>

      <Dialog open={isOpen.isTrue} onClose={isOpen.setFalse}>
        <CreateTermDialog projectId={projectId} closeDialog={isOpen.setFalse} />
      </Dialog>
    </>
  )
}
